




























import { Question } from '@/resource/question/question.model';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PublicQuestionInfo extends Vue {
  @Prop({ required: true })
  question!: Question;

  get form() {
    return `Form ${this.question.chapter.form - 6}`;
  }

  get chapter() {
    return `Chapter ${this.question.chapter.prefix}`;
  }

  get difficulties() {
    return [...Array(this.question.difficulty).keys()];
  }

  get emptyDifficulties() {
    return [...Array(3 - this.question.difficulty).keys()];
  }
}
